import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.PerformanceEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.PerformanceList })));

export default { edit, list };
